import React from 'react';
import { ScrollReveal } from '../components/ScrollReveal';
import { Brain, Sparkles, Zap } from 'lucide-react';
export function ScienceSection() {
  return <section className="bg-cosmic-card grid-pattern relative z-10 py-12 px-6 border-y border-white/5" data-id="element-227">
      <ScrollReveal className="max-w-5xl mx-auto flex flex-col items-center" data-id="element-228">
        <div className="mb-6 text-gold" data-id="element-229">
          <svg width="48" height="24" viewBox="0 0 48 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-230">
            <path d="M2 12h8l4-8 8 16 8-16 4 8h12" data-id="element-231" />
          </svg>
        </div>

        <p className="text-gold uppercase tracking-widest text-sm font-semibold mb-6 text-center" data-id="element-232">
          The Science Behind The Script
        </p>

        <h2 className="font-playfair text-lunar-white text-3xl md:text-5xl font-bold leading-tight mb-10 text-center max-w-3xl" data-id="element-233">
          Your Brain Has a 7-Minute
          <br data-id="element-234" />
          'Manifestation Window' Every Night.
          <br data-id="element-235" />
          <span className="text-lunar-lavender" data-id="element-236">Most Women Miss It.</span>
        </h2>

        <div className="text-lunar-white text-lg leading-relaxed font-lato space-y-6 max-w-2xl text-center mb-16" data-id="element-237">
          <p data-id="element-238">
            Modern neuroscience calls it the Theta State — the brief, powerful
            transition between wakefulness and deep sleep.
          </p>
          <p data-id="element-239">
            During these 7 minutes, your conscious mind — the one that says
            'this won't work' or 'I'm not good enough' — goes quiet.
          </p>
          <p data-id="element-240">
            What remains is pure subconscious access. This is the exact state
            where beliefs are written, rewritten, and permanently installed.
          </p>
          <p data-id="element-241">
            The Midnight Magnet Script was designed to be read during THIS
            window — so your deepest identity shifts from{' '}
            <span className="italic text-lunar-lavender" data-id="element-242">
              'the woman who waits'
            </span>{' '}
            to{' '}
            <span className="italic text-gold font-semibold" data-id="element-243">
              'the woman who is chosen.'
            </span>
          </p>
          <p className="font-semibold text-gold pt-4" data-id="element-244">
            No effort. No resistance. Just a 3-minute script and sleep.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full" data-id="element-245">
          {/* Card 1 */}
          <div className="bg-cosmic-deep border border-gold/30 rounded-xl p-8 flex flex-col items-center text-center hover:border-gold/60 transition-colors" data-id="element-246">
            <div className="bg-cosmic-card p-4 rounded-full mb-6 border border-gold/20" data-id="element-247">
              <Brain className="w-8 h-8 text-gold" data-id="element-248" />
            </div>
            <h3 className="text-xl font-playfair font-bold text-lunar-white mb-4" data-id="element-249">
              Theta State Activation
            </h3>
            <p className="text-lunar-lavender leading-relaxed" data-id="element-250">
              The brain's most receptive state. Open. Unguarded. Ready to
              receive new instructions without the ego's interference.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-cosmic-deep border border-gold/30 rounded-xl p-8 flex flex-col items-center text-center hover:border-gold/60 transition-colors" data-id="element-251">
            <div className="bg-cosmic-card p-4 rounded-full mb-6 border border-violet/40" data-id="element-252">
              <Sparkles className="w-8 h-8 text-violet" data-id="element-253" />
            </div>
            <h3 className="text-xl font-playfair font-bold text-lunar-white mb-4" data-id="element-254">
              Subconscious Rewiring
            </h3>
            <p className="text-lunar-lavender leading-relaxed" data-id="element-255">
              Old "I'm not enough" beliefs dissolve effortlessly as you drift to
              sleep, replaced by deep, magnetic worthiness.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-cosmic-deep border border-gold/30 rounded-xl p-8 flex flex-col items-center text-center hover:border-gold/60 transition-colors" data-id="element-256">
            <div className="bg-cosmic-card p-4 rounded-full mb-6 border border-electric/40" data-id="element-257">
              <Zap className="w-8 h-8 text-electric" data-id="element-258" />
            </div>
            <h3 className="text-xl font-playfair font-bold text-lunar-white mb-4" data-id="element-259">
              Pattern Break
            </h3>
            <p className="text-lunar-lavender leading-relaxed" data-id="element-260">
              Replace the desperate energy of 'I chase' with the calm certainty
              of 'I attract' at the cellular level.
            </p>
          </div>
        </div>
      </ScrollReveal>
    </section>;
}